export function useLoading(defaultState = true) {
  const inProgress = ref<boolean>(defaultState);

  const start = async () => (inProgress.value = true);
  const stop = () => (inProgress.value = false);

  return {
    inProgress,
    start,
    stop,
  };
}
